import { queryOptions, useQuery } from '@tanstack/react-query';

import httpService from '@/lib/http.service';
import { QueryConfig } from '@/lib/react-query';

type Params = {
  objectItemId?: number;
  objectId: number;
  garbageId: number;
};

export const getAdditionalDischarges = async (params: Params) => {
  const { data } = await httpService.get<
    {
      objectItemId: number;
      additionalDischarges: {
        date: string;
        successPrice: string;
        failPrice: string;
        failPriceWithVat: string;
        successPriceWithVat: string;
      }[];
    }[]
  >(`/self-service/objects/additional-discharges`, {
    params,
  });
  return data;
};

export const getAdditionalDischargesQueryOptions = (params: Params) => {
  return queryOptions({
    queryKey: ['additional-discharges', params],
    queryFn: () => getAdditionalDischarges(params),
  });
};

type UseAdditionalDischargesOptions = {
  params: Params;
  queryConfig?: QueryConfig<typeof getAdditionalDischargesQueryOptions>;
};

export const useGetAdditionalDischarges = ({ params, queryConfig }: UseAdditionalDischargesOptions) => {
  return useQuery({
    ...getAdditionalDischargesQueryOptions(params),
    ...queryConfig,
  });
};
